import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Row, Col } from 'antd';
import moment from 'moment';

const { Panel } = Collapse;

function TabelaUtilizacao({ folhasUsadasPorCompetencia }) {
  return (
    <Collapse ghost>
      {Object.entries(folhasUsadasPorCompetencia).map(([competencia, folhas]) => (
        <Panel
          header={
            <span>
              {moment(competencia).format('MM-YYYY')}
              &nbsp;
              <strong>({folhas.length} Folhas)</strong>
            </span>
          }
          key={competencia}
        >
          <Row>
            {folhas.map(({ nomeFolha }) => (
              <Col
                xs={24}
                sm={12}
                md={12}
                lg={12}
                xl={12}
              >
                {nomeFolha}
              </Col>
            ))}
          </Row>
        </Panel>
      ))}
    </Collapse>
  );
}

TabelaUtilizacao.propTypes = {
  folhasUsadasPorCompetencia: PropTypes.oneOf.isRequired,
};

export default TabelaUtilizacao;
